// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Recebimentos_GetavailablerecebimentosforpaymentrulesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Recebimentos_GetavailablerecebimentosforpaymentrulesRow } from './Recebimentos_GetavailablerecebimentosforpaymentrulesRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Recebimentos_GetavailablerecebimentosforpaymentrulesResponseDados = Recebimentos_GetavailablerecebimentosforpaymentrulesRow[];

export type Recebimentos_GetavailablerecebimentosforpaymentrulesResponse = ApiResponse<Recebimentos_GetavailablerecebimentosforpaymentrulesResponseDados>;

registerResponseContract('Recebimentos_GetavailablerecebimentosforpaymentrulesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      recebimento_id:                 { type: 'number',  required: true },
      recebimento_data_cadastro:      { type: 'string',  required: false },
      recebimento_data:               { type: 'string',  required: false },
      recebimento_franquia_id:        { type: 'number',  required: false },
      recebimento_forma_pagamento_id: { type: 'number',  required: false },
      recebimento_valor:              { type: 'number',  required: false },
      recebimento_valor_taxas:        { type: 'number',  required: false },
      recebimento_valor_liquido:      { type: 'number',  required: false },
      recebimento_provedor:           { type: 'string',  required: false },
      recebimento_origem:             { type: 'string',  required: true },
      recebimento_origem_id:          { type: 'number',  required: false },
      recebimento_registrado_por:     { type: 'string',  required: true },
      recebimento_registrado_por_id:  { type: 'string',  required: true },
      recebimento_id_externo:         { type: 'string',  required: false },
      recebimento_conta_externa_id:   { type: 'number',  required: false },
      recebimento_payroll_period_id:  { type: 'number',  required: false },
      recebimento_observacoes:        { type: 'string',  required: false },
      recebimento_data_disponivel:    { type: 'string',  required: false },
      compromisso_user_id:            { type: 'string',  required: false },
      compromisso_data:               { type: 'string',  required: false },
      orcamento_user_id:              { type: 'number',  required: false },
    },
  },
})
